import { distributionAccountState } from "./accounts/state";
import { distributionOrderState } from "./orders/state";
import { importsState } from "./imports/state";
import { distributionStatementsState } from "./statement/state";
import { distributionSupplierState } from "./suppliers/state";
import { shopsDistributionState } from "./shops/state";
import { shop_groupsDistributionState } from "./shop_groups/state";
import { DistributionModulePluginStore } from "./plugin-store";
import { distributionSupplierOrderState } from "./supplier_orders/state";
import { distributionReleaseReportState } from "./release_report/state";
export const state = {
  ...importsState,
  ...distributionAccountState,
  ...distributionOrderState,
  ...distributionSupplierState,
  ...distributionStatementsState,
  ...shopsDistributionState,
  ...shop_groupsDistributionState,
  ...distributionSupplierOrderState,
  ...distributionReleaseReportState,
  ...DistributionModulePluginStore.state,
};
